import { useEffect } from 'react'

import { match } from 'ts-pattern'

import { DrawerSearchResult } from '~/features/map-page/components/drawer-search-result'
import { Facility, Office, Type } from '~/models/types'

import { Map } from '../components/'
import {
  drawerContent,
  drawerPosition,
  MapProvider,
  useMapContext,
  useMapDispatchContext,
} from '../context'

// NOTE: ドロワーのレスポンシブのブレイクポイント。tailwindのmdを使用
const RESPONSIVE_BREAKPOINT = 768

type MapCenterLocation = {
  lat: number
  lng: number
  radius: number | null
}

type MapPageProps = {
  offices: React.ComponentProps<typeof Map>['offices']
  officeTypes: Type[]
  facilities: Pick<Facility, 'id' | 'name' | 'order'>[]
  totalResultCount: number
  initialMapCenterLocation: MapCenterLocation
  initialFormValues: React.ComponentProps<
    typeof DrawerSearchResult
  >['initialFormValues']
  initialSelectedOffice: Office | null
}

type MapPageContentProps = MapPageProps

const MapPageContent = ({
  offices,
  totalResultCount,
  initialMapCenterLocation,
  officeTypes,
  facilities,
  initialFormValues,
}: MapPageContentProps) => {
  const { currentDrawerContent } = useMapContext()
  const { setDrawerPosition } = useMapDispatchContext()

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < RESPONSIVE_BREAKPOINT
      const newPosition = match({ isMobile, currentDrawerContent })
        .with(
          { isMobile: true, currentDrawerContent: drawerContent.searchForm },
          () => drawerPosition.full,
        )
        .with({ isMobile: true }, () => drawerPosition.bottom)
        .otherwise(() => drawerPosition.left)

      setDrawerPosition(newPosition)
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [currentDrawerContent, setDrawerPosition])

  return (
    <Map
      facilities={facilities}
      initialFormValues={initialFormValues}
      initialMapCenterLocation={initialMapCenterLocation}
      officeTypes={officeTypes}
      offices={offices}
      totalResultCount={totalResultCount}
    />
  )
}

export const MapPage = (props: MapPageProps) => {
  return (
    <MapProvider initialSelectedOffice={props.initialSelectedOffice}>
      <MapPageContent {...props} />
    </MapProvider>
  )
}
